import EditIcon from '@mui/icons-material/Edit';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, Button } from '@mui/material';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import React, { FC, memo, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { usePermissionWrapper } from 'src/components/common/hooks/usePermissionWrapper';
import { AppState, useAppSelector } from 'src/store';
import { setDocumentDetail } from 'src/store/documentDetail';
import DocManagementService from '../documentUpload/service/DocManagementService';
import QualityControl from './QualityControl';
import { EditMetaDataProps } from './types';

const QualityControlDetail: FC<any> = ({
  expanded,
  accordionInfo,
  actionType,
  handleToogleAccordion,
  status
}: EditMetaDataProps) => {
  const documentDetail: any = useSelector((state: AppState) => state.documentDetail);
  const user: any = useAppSelector(state => state.user.user);
  const selectedStudy = useSelector((state: AppState) => state.searchHierarchyDetails?.data[0]?.Study);
  const selectedCountry = useSelector((state: AppState) => state.searchHierarchyDetails?.data[0]?.Country);
  const selectedSite = useSelector((state: AppState) => state.searchHierarchyDetails?.data[0]?.Site);

  let TmfLevel =
    (selectedStudy === '--' || selectedStudy === '') &&
    (selectedCountry === '--' || selectedCountry == '') &&
    (selectedSite === '--' || selectedSite === '')
      ? '--'
      : (selectedCountry === '--' || selectedCountry == '') && (selectedSite === '--' || selectedSite === '')
      ? 'Study'
      : selectedSite === '--' && selectedCountry != '--'
      ? 'Country'
      : 'Site';
  if (TmfLevel === '--') {
    TmfLevel = 'Study';
  }
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const { checkPermission } = usePermissionWrapper();
  const docService = new DocManagementService();

  const getQCDetails = () => {
    const params = {
      module_section_related: 'DocumentDetails',
      parent_entity_related: documentDetail.data[0].tmf_document_name
    };
    const result: any = docService.getQCDetails(
      params,
      documentDetail.data[0]?.id,
      selectedStudy,
      selectedCountry,
      selectedSite,
      TmfLevel
    );
    const qualityControl = result?.data?.quality_control;
    // const qualityCheck =
    //   documentDetail.data[0].tmf_doc_viewer_req_certified_copy === 'Y' &&
    //   (documentDetail.data[0].tmf_doc_status === 'Ready for approval' ||
    //     documentDetail.data[0].tmf_doc_status === 'Approved')
    //     ? true
    //     : documentDetail.data[0].is_checkbox_verified;
    setDocumentDetail(dispatch, [
      {
        ...documentDetail.data[0],
        is_checkbox_verified: qualityControl ? qualityControl.is_checkbox_verified : false,
        tmf_doc_viewer_qc_issue_type: qualityControl
          ? qualityControl.tmf_doc_viewer_qc_issue_type
          : documentDetail.data[0].tmf_doc_viewer_qc_issue_type,
        tmf_doc_viewer_qc_issue_comments: qualityControl
          ? qualityControl.tmf_doc_viewer_qc_issue_comments
          : documentDetail.data[0].tmf_doc_viewer_qc_issue_commentsqualityControl,
        tmf_doc_viewer_req_certified_copy: qualityControl
          ? qualityControl.tmf_doc_viewer_req_certified_copy
          : documentDetail.data[0].tmf_doc_viewer_req_certified_copy,
        tmf_quality_control_table_id: qualityControl?.id,
        is_submit: qualityControl?.is_submit,
        is_active: qualityControl?.is_active,
        users: result?.data?.users
      }
    ]);
  };

  const qcRows = [
    createData('QC Issue Type:', documentDetail.data[0].tmf_doc_viewer_qc_issue_type),
    createData('QC Issue Comments:', documentDetail.data[0].tmf_doc_viewer_qc_issue_comments),
    createData('Certified Copy?:', documentDetail.data[0].is_checkbox_verified ? 'Yes' : 'No')
  ];

  useEffect(() => {
    getQCDetails();
  }, [status]);

  function createData(name: string, calories: string | null) {
    return { name, calories };
  }

  const handleClickOpen = (event: any) => {
    if (documentDetail.data[0].tmf_doc_viewer_req_certified_copy === 'Y') {
      setOpen(true);
    }
    event.stopPropagation();
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Accordion
        expanded={accordionInfo.position === expanded}
        onChange={handleToogleAccordion(accordionInfo.position)}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2bh-content" id="panel2bh-header">
          <Typography sx={{ width: '60%', flexShrink: 0 }} className="acc-header">
            Quality Control{' '}
            {checkPermission('update_qc_details') && (
              <Button
                disabled={
                  documentDetail.data[0] &&
                  (documentDetail.data[0].is_submit ||
                    documentDetail.data[0].is_checkbox_verified ||
                    documentDetail.data[0].tmf_doc_viewer_req_certified_copy !== 'Y' ||
                    documentDetail.data[0].tmf_doc_status === 'Approved' ||
                    (documentDetail.data[0].tmf_doc_latest_version &&
                      parseFloat(documentDetail.data[0] && documentDetail.data[0].tmf_doc_version_number)?.toFixed(
                        1
                      ) !==
                        parseFloat(documentDetail.data[0] && documentDetail.data[0].tmf_doc_latest_version)?.toFixed(
                          1
                        )))
                }
                onClick={event => handleClickOpen(event)}
              >
                <EditIcon />
              </Button>
            )}
            {!checkPermission('update_required_certificate_copy') && (
              <Button disabled={!checkPermission('update_required_certificate_copy')}>
                <EditIcon />
              </Button>
            )}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            <TableContainer component={Paper}>
              <Table aria-label="simple table">
                <TableBody>
                  {qcRows.map(row => (
                    <TableRow key={row.name} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                      <TableCell component="th" scope="row">
                        {row.name}
                      </TableCell>
                      <TableCell align="right">{row.calories}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Typography>
        </AccordionDetails>
      </Accordion>
      <QualityControl handleClose={handleClose} open={open} setOpen={setOpen} status={status}></QualityControl>
    </>
  );
};

export default memo(QualityControlDetail);
